import { createActionCreator } from 'deox';
import { LegalDocumentType } from '@/types';

export const loadLegalDocumentActions = {
  request: createActionCreator('LOAD_LEGAL_DOCUMENT_REQUEST', (resolve) => (legalDocumentType: LegalDocumentType) =>
    resolve({ legalDocumentType })
  ),
  success: createActionCreator(
    'LOAD_LEGAL_DOCUMENT_SUCCESS',
    (resolve) => (legalDocumentType: LegalDocumentType, html: string) => resolve({ legalDocumentType, html })
  ),
  failure: createActionCreator('LOAD_LEGAL_DOCUMENT_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};
